import * as z from "zod/v4";

export const updateReturnViewFolderName = {
  name: "updateReturnViewFolderName" as const,
  input: z.object({ folderId: z.string(), name: z.string() }),
  output: z.object({}),
};
